import React from 'react'
import '../Theme.css';
import './Button.css';

function Button({style, textStyle, text, onClick}) {
    const className = "Button " + style;
    const textClass = "ButtonText " + textStyle;
    return (
        <button className={className} onClick={onClick}>
            <p className={textClass}>{text}</p>
        </button>
    )
}

export default Button;
